import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Flex, Tag } from 'antd';
import MaterialIcon from "material-icons-react";
import { Link, useNavigate } from "react-router-dom";
import kazi from "../../assets/kazi.png"
import jobImg from "../../assets/NEA-logo.png";
import moment from "moment";
import {
  clearActiveJob,
  fetchJobs,
  fetchSaveJobs,
  saveSaveJob,
  setActiveJob,
} from "../../features/job/jobSlice";
import JobFilter from "./JobFilter";
import toast from "react-hot-toast";

export default function JobCard({ latest, closed }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { jobs } = useSelector((state) => state.job);
  const now = Date.now();

  const { user } = useSelector((state) => state.auth);

  const [jobList, setJobList] = useState([]);


  useEffect(() => {

    if (latest) {
      setJobList(jobs.filter(job => job.closingDate > now));
    } else if (closed) {
      setJobList(jobs.filter(job => job.closingDate < now));
      console.log(jobList.length, now,);
    } else {
      setJobList(jobs);
    }

  }, [jobs, latest, closed]);


  const filterObj = {
    jobRecommendation: "",
    jobCountry: "",
    jobCategory: "",
    jobExperienceLevel: "",
    jobType: "",
    jobWorkStyle: "",
    jobName: "",
    jobOccupation: "",
  };

  async function handleFetchJobs() {
    await dispatch(fetchJobs(filterObj));
  }

  async function handleSaveJob(item) {
    const jobObj = {
      josUsrId: user?.usrId,
      josJobId: item?.jobId,
      josCreatedBy: user?.usrId,
    };

    const res = await dispatch(saveSaveJob(jobObj));
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await dispatch(fetchSaveJobs(jobObj));
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  }

  async function handleClearActiveJob() {
    await dispatch(clearActiveJob());
  }

  async function handleActiveJob(item) {
    await dispatch(setActiveJob(item));
    await navigate(
      `/job-info/${item?.jobId}/${item?.jobPosition}`.replace(/\s+/g, "-")
    );
  }

  useEffect(() => { }, [jobList]);

  useEffect(() => {
  }, [jobs]);

  useEffect(() => {
    handleFetchJobs();
    handleClearActiveJob();
  }, []);

  return (
    <>
      <div className='flex bg-white p-5 w-[100vw] md:w-[100%] h-fit pb-16 mt-3'>
        <div className='w-full mr-5'>
          <p className='job-count mt-7 mb-5'>{jobList.length} Job(s)</p>

          {jobList.length > 0 ? jobList?.map((item) => {
            return (
              <>
                <div
                  style={{
                    border: "1px solid rgba(20, 20, 20, 0.05)",
                  }}
                  className='flex rounded-[8px] p-[10px] md:p-[24px] space-x-4 mb-4'
                >
                  <div className='hidden md:flex flex-shrink-0'>
                    <img
                      className='w-[70px] h-[75px] rounded-[4px]'
                      src={jobImg}
                      alt='N'
                    />
                  </div>
                  <div className='flex-1 min-w-0'>
                    <p className='text-black14 font-bold text-[12px] md:text-[18px]'>
                      {item?.jobTitle}
                    </p>
                    <div className='flex justify-between items-center w-full'>
                      <p className='text-black14 font-[500] text-[11px] md:text-[15px] my-2'>
                        {item?.jobTitle}
                      </p>

                      <div className='flex flex-col'>
                        <div className='flex !items-center'>
                          {/* {item?.closingDate > now ?  */}
                          <button
                            type='button'
                            onClick={() => handleActiveJob(item)}
                            className='job-apply-text'
                          >
                            Apply
                          </button>
                          {/* :
                            <span className='p-1 bg-lightPurple text-darkPurple w-fit rounded-[5px] text-[11px] md:text-[14px] font-medium'>
                              expired
                            </span> */}
                          {/* } */}

                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='24'
                            height='24'
                            viewBox='0 0 24 24'
                            fill='none'
                          >
                            <path
                              d='M9 18L15 12L9 6'
                              stroke='#147CBC'
                              stroke-width='2'
                              stroke-linecap='round'
                              stroke-linejoin='round'
                            />
                          </svg>
                        </div>
                      </div>
                    </div>

                    <div className='flex items-center'>
                      <span className='p-1 bg-lightPurple text-darkPurple w-fit rounded-[5px] text-[10px]  md:text-[14px] font-medium'>
                        Job Grade: {item?.jobGrade}
                      </span>

                      <span className='p-1 bg-lightPurple text-darkPurple w-fit rounded-[5px] ml-8 md:ml-4 text-[10px] md:text-[14px] font-medium'>
                        Job Reference No: {item?.jobReferenceNo}
                      </span>
                    </div>

                    <div className='flex justify-between items-center'>
                      <div className='flex items-center flex-wrap text-blackrgb mt-3'>
                        <div className='flex items-center mr-7'>
                          <span className='font-normal text-[10px] text-[15px] ml-1'>
                            salary: confidential
                          </span>
                        </div>

                        <div className='flex items-center mr-7'>
                          <MaterialIcon
                            size={20}
                            color='rgba(20, 20, 20, 0.70)'
                            icon='calendar_today'
                          />
                          {/* <span className='font-normal text-[14px] ml-1'>
                            Ends{" "}
                            {moment(item?.closingDate).startOf("day").fromNow()}
                          </span> */}
                        </div>
                      </div>

                      <div className='flex items-center justify-end'>
                        <button
                          onClick={() => handleSaveJob(item)}
                          className='rounded-full p-1 bg-[#F4F9FB]'
                        >
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='30'
                            height='30'
                            viewBox='0 0 38 38'
                            fill='none'
                          >
                            <circle cx='19' cy='19' r='19' fill='#F4F9FB' />
                            <path
                              d='M14 28.5122V13.3665C14 13.0021 14.1108 12.6833 14.3325 12.41C14.5542 12.1367 14.8128 12 15.1083 12H23.2361C23.5317 12 23.7903 12.1367 24.0119 12.41C24.2336 12.6833 24.3444 13.0021 24.3444 13.3665V28.5122L19.1722 25.7791L14 28.5122ZM15.1083 26.4396L19.1722 24.3215L23.2361 26.4396V13.3665H15.1083V26.4396Z'
                              fill='#333333'
                            />
                          </svg>
                        </button>

                        <button className='rounded-full p-1 bg-[#F4F9FB] ml-3'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='22'
                            height='22'
                            viewBox='0 0 19 18'
                            fill='none'
                          >
                            <path
                              d='M14.158 16.3872C13.573 16.3872 13.0758 16.1818 12.6663 15.7712C12.2569 15.3605 12.0521 14.8619 12.0521 14.2752C12.0521 14.1931 12.0614 14.0926 12.0798 13.9739C12.0983 13.8551 12.126 13.7483 12.163 13.6533L6.56587 10.4022C6.38115 10.6115 6.15332 10.7808 5.8824 10.9101C5.61147 11.0394 5.33439 11.1041 5.05115 11.1041C4.46619 11.1041 3.96898 10.8994 3.55951 10.4899C3.15005 10.0804 2.94531 9.58322 2.94531 8.99826C2.94531 8.41331 3.15005 7.9161 3.55951 7.50663C3.96898 7.09716 4.46619 6.89243 5.05115 6.89243C5.33439 6.89243 5.60531 6.94785 5.86392 7.05868C6.12253 7.16951 6.35652 7.32961 6.56587 7.53896L12.163 4.32479C12.126 4.23771 12.0983 4.13974 12.0798 4.03088C12.0614 3.92203 12.0521 3.81681 12.0521 3.71521C12.0521 3.13025 12.2569 2.63304 12.6663 2.22358C13.0758 1.81411 13.573 1.60938 14.158 1.60938C14.7429 1.60938 15.2401 1.81411 15.6496 2.22358C16.0591 2.63304 16.2638 3.13025 16.2638 3.71521C16.2638 4.30016 16.0591 4.79737 15.6496 5.20684C15.2401 5.61631 14.7429 5.82104 14.158 5.82104C13.8704 5.82104 13.5953 5.77486 13.3327 5.6825C13.0701 5.59014 12.8464 5.43928 12.6617 5.22993L7.06462 8.33326C7.08925 8.43178 7.1108 8.54569 7.12927 8.675C7.14774 8.80431 7.15698 8.91354 7.15698 9.00272C7.15698 9.0919 7.14774 9.18426 7.12927 9.2798C7.1108 9.37535 7.08925 9.47238 7.06462 9.5709L12.6617 12.7481C12.8464 12.5757 13.0619 12.4372 13.3082 12.3325C13.5545 12.2278 13.8378 12.1755 14.158 12.1755C14.7429 12.1755 15.2401 12.3802 15.6496 12.7897C16.0591 13.1992 16.2638 13.6964 16.2638 14.2813C16.2638 14.8663 16.0591 15.3635 15.6496 15.773C15.2401 16.1824 14.7429 16.3872 14.158 16.3872ZM14.1586 4.71271C14.4414 4.71271 14.6783 4.61705 14.8691 4.42574C15.06 4.23443 15.1555 3.99737 15.1555 3.71456C15.1555 3.43175 15.0598 3.19491 14.8685 3.00403C14.6772 2.81315 14.4401 2.71771 14.1573 2.71771C13.8745 2.71771 13.6377 2.81336 13.4468 3.00467C13.2559 3.19598 13.1605 3.43304 13.1605 3.71585C13.1605 3.99866 13.2561 4.23551 13.4474 4.42639C13.6387 4.61727 13.8758 4.71271 14.1586 4.71271ZM5.05179 9.99576C5.3346 9.99576 5.57145 9.90011 5.76233 9.7088C5.95321 9.51749 6.04865 9.28043 6.04865 8.99762C6.04865 8.71481 5.95299 8.47796 5.76168 8.28708C5.57037 8.0962 5.33331 8.00076 5.0505 8.00076C4.76769 8.00076 4.53084 8.09642 4.33997 8.28773C4.14909 8.47904 4.05365 8.7161 4.05365 8.99891C4.05365 9.28172 4.1493 9.51857 4.34061 9.70944C4.53192 9.90032 4.76898 9.99576 5.05179 9.99576ZM14.1586 15.2788C14.4414 15.2788 14.6783 15.1832 14.8691 14.9919C15.06 14.8005 15.1555 14.5635 15.1555 14.2807C15.1555 13.9979 15.0598 13.761 14.8685 13.5701C14.6772 13.3793 14.4401 13.2838 14.1573 13.2838C13.8745 13.2838 13.6377 13.3795 13.4468 13.5708C13.2559 13.7621 13.1605 13.9992 13.1605 14.282C13.1605 14.5648 13.2561 14.8016 13.4474 14.9925C13.6387 15.1834 13.8758 15.2788 14.1586 15.2788Z'
                              fill='#333333'
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })
            : <div className="flex flex-col w-full h-full  items-center ">
              <img src={kazi} alt="Job" />
              <div className="text-xl mt-10">No jobs found using above criteria</div>
            </div>
          }
        </div>
        <div
          style={{
            border: "1px solid rgba(20, 20, 20, 0.05)",
          }}
          className='hidden md:flex flex-col p-[23px] bg-[#f8fcff] mt-2 w-[27%]'
        >
          <h3 className='job-filter-text'>Job Filter</h3>
          <JobFilter />
        </div>
      </div>
    </>
  );
}
